var map = {
	"./arunjoshy.webp": 25864,
	"./baskar.webp": 18837,
	"./chitradevi.webp": 61940,
	"./deepika.webp": 69258,
	"./dhivyabharathi.webp": 5036,
	"./jonyblessingmanoj.webp": 95555,
	"./kavinya.webp": 84460,
	"./kavitha.webp": 66483,
	"./mohanapriya.webp": 74478,
	"./raghu.webp": 30166,
	"./ramya.webp": 5385,
	"./sangeetha.webp": 39387,
	"./senthilkumar.webp": 64524,
	"./shivaswamy.webp": 24591,
	"./srimohanapriya.webp": 57160,
	"./sudha.webp": 43976
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4659;